import { useMutation, UseQueryOptions } from '@tanstack/react-query';
import { apiBearerIam } from '~/services/api';
import { HttpData } from '~/utils/network/HttpData';

export type UserExportPayload<T> = {
  config?: UseQueryOptions<T>;
  payload: {
    marketing_email: string[];
    location: string[];
    specialities_ids: number[];
    status: string[];
  };
};

export interface UserExportResponse {
  csv: string;
}

export const useUserExport = () => {
  return useMutation<HttpData<UserExportResponse>, Error, void>({
    mutationKey: ['user', 'export'],
    mutationFn: async (payload: any) => {
      const response = await apiBearerIam({})
        .post(
          `iam/user/v1/export-members`,
          {
            ...payload,
          },
          {
            paramsSerializer: { indexes: null },
            responseType: 'blob',
          }
        )
        .then((response) => {
          // Extract filename from Content-Disposition header
          let filename = `members.csv`;
          const disposition = response.headers['content-disposition'];
          if (disposition) {
            const match = disposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
              filename = match[1];
            }
          }

          // process to download response file from api as csv
          const href = window.URL.createObjectURL(response.data);

          const anchorElement = document.createElement('a');

          anchorElement.href = href;
          anchorElement.download = filename;

          document.body.appendChild(anchorElement);
          anchorElement.click();

          document.body.removeChild(anchorElement);
          window.URL.revokeObjectURL(href);
        });
    },
  });
};
